module.exports = __webpack_public_path__ + "img/facts-all_2019.ba4dd582.png";